import * as api from '../../../api/employee/employeeApi';
import {
  FETCH_EMPLOYEES_REQUEST,
  FETCH_EMPLOYEES_SUCCESS,
  FETCH_EMPLOYEES_FAILURE,
  // CREATE_EMPLOYEE,
  // UPDATE_EMPLOYEE,
  // DELETE_EMPLOYEE,
  CREATE_EMPLOYEE_REQUEST,
  CREATE_EMPLOYEE_SUCCESS,
  CREATE_EMPLOYEE_FAILURE,
  UPDATE_EMPLOYEE_REQUEST,
  UPDATE_EMPLOYEE_SUCCESS,
  UPDATE_EMPLOYEE_FAILURE,
  DELETE_EMPLOYEE_REQUEST,
  DELETE_EMPLOYEE_SUCCESS,
  DELETE_EMPLOYEE_FAILURE
} from '../../types/employee/employeeTypes';

export const fetchEmployees = () => async (dispatch) => {
  dispatch({ type: FETCH_EMPLOYEES_REQUEST });
  try {
    const response = await api.fetchEmployees();
    dispatch({ type: FETCH_EMPLOYEES_SUCCESS, payload: response.data });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch employees';
    dispatch({ type: FETCH_EMPLOYEES_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};

export const createEmployee = (data) => async (dispatch) => {
  dispatch({ type: CREATE_EMPLOYEE_REQUEST });
  try {
    const response = await api.createEmployee(data);
    // Compose the new employee object for the reducer
    const newEmployee = { id: response.data.id, ...response.data.data };
    dispatch({ type: CREATE_EMPLOYEE_SUCCESS, payload: newEmployee });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to create employee';
    dispatch({ type: CREATE_EMPLOYEE_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};

export const updateEmployee = (id, data) => async (dispatch) => {
  dispatch({ type: UPDATE_EMPLOYEE_REQUEST });
  try {
    const response = await api.updateEmployee(id, data);
    dispatch({ type: UPDATE_EMPLOYEE_SUCCESS, payload: { id, data } });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to update employee';
    dispatch({ type: UPDATE_EMPLOYEE_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};

export const deleteEmployee = (id) => async (dispatch) => {
  dispatch({ type: DELETE_EMPLOYEE_REQUEST });
  try {
    const response = await api.deleteEmployee(id);
    dispatch({ type: DELETE_EMPLOYEE_SUCCESS, payload: id });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to delete employee';
    dispatch({ type: DELETE_EMPLOYEE_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};
